// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__TZ5ix","dark":"Navbar_dark__nS8wB","light":"Navbar_light__ITDDU","active":"Navbar_active__NyZR3","link":"Navbar_link__8I2fz"};